import { Dayts } from '@/utils';
import { TIME_FORMAT } from '@/constants';

export const cleanTimeRegExp = new RegExp(`[^0-9:.]`, 'g');
export const formatTime =
  (format: string = TIME_FORMAT): ((value: string) => string) =>
  (value: string = ''): string => {
    if (!value || typeof value !== 'string') return '';
    let hours = 0,
      minutes = 0,
      seconds = 0,
      milliseconds = 0;
    let input = value.trim();
    if (input.includes(':')) {
      // Split by colon, handle up to HH:mm:ss.SSS
      const [h, m = '0', s = '0'] = input.split(':');
      const msSplit = s.split('.');
      hours = parseInt(h, 10) || 0;
      minutes = parseInt(m, 10) || 0;
      seconds = parseInt(msSplit[0], 10) || 0;
      milliseconds = msSplit[1] ? parseInt(msSplit[1], 10) || 0 : 0;
    } else {
      // Fallback: treat as digits, pad to 4 for HHmm
      const digits = input.replace(cleanTimeRegExp, '').padStart(4, '0');
      hours = parseInt(digits.substring(0, 2), 10) || 0;
      minutes = parseInt(digits.substring(2, 4), 10) || 0;
      if (digits.length > 4) seconds = parseInt(digits.substring(4, 6), 10) || 0;
      if (digits.length > 6) milliseconds = parseInt(digits.substring(6, 9), 10) || 0;
    }
    // Cap values
    if (hours > 23) hours = 23;
    if (minutes > 59) minutes = 59;
    if (seconds > 59) seconds = 59;
    if (milliseconds > 999) milliseconds = 999;
    // Build time string for Dayts
    let timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    if (format.includes('ss')) timeString += `:${seconds.toString().padStart(2, '0')}`;
    if (format.includes('SSS')) timeString += `.${milliseconds.toString().padStart(3, '0')}`;
    // Use Dayts for formatting
    return new Dayts().setTime(timeString).format(format);
  };
